<template>
  <div>
    <div class="MuiPaper-root jss40 MuiPaper-elevation1 MuiPaper-rounded">
      <div class="jss42">
        <div class="jss43">
          <div class="MuiContainer-root MuiContainer-maxWidthMd">
            <div class="MuiTypography-root jss45 MuiTypography-alignCenter">
              <home-logo></home-logo>
            </div>
            <div class="MuiTypography-root MuiTypography-alignCenter MuiTypography-subTitle white--text">A decentralized
              autonomous organization (DAO) owned by its artists members</div>
          </div>
        </div>
      </div>
      <div class="upgrade-btn">
        <menu-bar></menu-bar>
      </div>
    </div>
    <div class="MuiContainer-root jss638 MuiContainer-maxWidthMd">
      <div class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-5 MuiGrid-justify-xs-center">
        <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-8 MuiGrid-grid-md-10">
          <div class="MuiTypography-root MuiTypography-h1 ml-4 fw-700 MuiTypography-alignCenter rainbow_underline"><a
              href="https://solsea.io/collection/620885aa80d5844492bb7e6a" class="del-underline" target="_blank">THE
              REMASTERED COLLECTION (TRC)</a>
          </div>
          <div class="jss52 text-center mt-8">
            <div class="sc-iCfMLu eDTiIH">
              <div class="mb-4">A comprehensive collection of award-winning artists' lifetime works produced by artWormz
                DAO.</div>
              <div class="mb-4">These original artworks are in museums and private collections worldwide. Digital rights
                for all the works in this collection were retained by artWormz DAO.</div>
              <div class="mb-4">
                Through use of non-fungible token technology, artWormz DAO will accelerate the impact of original
                artworks created by a variety of accomplished artists over the past three decades, democratizing the art
                market, and re-incentivizing the artists with the proceeds.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="placeHolder" id="today"></div>
      <div class="MuiContainer-root jss100 MuiContainer-maxWidthMd">
        <div class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-5 MuiGrid-justify-xs-center">
          <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-8 MuiGrid-grid-md-10">
            <div class="MuiTypography-root jss51 MuiTypography-h3 MuiTypography-alignLeft">The TODAY Series</div>
            <div class="jss52">
              <div class="sc-iCfMLu eDTiIH">
                <div class="mb-4">World premier live exhibition at the Serbian Pavilion at the Dubai Expo 2020, starting
                  on
                  February 18 and ending on March 11, 2022. </div>
                <div class="mb-4">Through this TODAY Series, we are offering 34 NFTs worth over $450,000 for sale
                  execlusive through SolSea.</div>
                <div class="mb-4">
                  <!-- <video src="https://images.iob.community/artwormz/2022/02/Dubai-SM-M.mp4" autoplay="autoplay"
                    muted="muted" bindended="EventHandle" controls="false" controlsList="nodownload" width="480"
                    height="100%" style="transition: opacity 1s ease 0s;" class="jss648 jss659" draggable="false" />
                  </video> -->
                  <div style="position: relative; padding-top: 56.25%;">
                    <iframe src="https://customer-cc44yfs1ng5d1ck2.cloudflarestream.com/42da42ab7ee8a5516f6efb600e583ca6/iframe?muted=true&preload=true&loop=true&autoplay=true&poster=https%3A%2F%2Fcustomer-cc44yfs1ng5d1ck2.cloudflarestream.com%2F42da42ab7ee8a5516f6efb600e583ca6%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600" style="border: none; position: absolute; top: 0; left: 0; height: 100%; width: 100%;" allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;" allowfullscreen="true">
                    </iframe>
                  </div>
                </div>
                <div class="mb-4">"The past was already past. The future is still far off. Today, today, only today."
                  These are the words of Chinese poet Bei Dao, which serve as the theme of our exhibition.</div>
                <div class="mb-4">
                  In this exhibition, we see the relationship between man and nature, animals and machines, as well as
                  the
                  lust for power and money. You'll see how an artist imagines an unknown future from his perspective.
                  While
                  you're feeling such uneasiness and uncertainty, you feel the emotions that accompany it.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="MuiContainer-root jss53 mt-8 MuiContainer-maxWidthXl">
      <div class="jss54">
        <!-- 1. Yin Kun -->
        <div v-for="(artsit,index) in artsitList" :key="artsit.id">
          <div class="jss56" data-testid="base-card">
            <div class="jss59">
              <!-- router-link to="/artsit" class="del-underline" data-testid="item-detail-link"> -->
              <router-link :to="'/artsit/' + artsit.author.toLowerCase().replace(' ', '')" class="del-underline"
                data-testid="item-detail-link">
                <div class="jss57">
                  <img :src="artsit.avator" class="img_gray" alt=""
                    style="pointer-events: none; position: absolute; top: 0px; left: 0px; width: 100%; height: 100%; object-fit: cover; z-index: -1;">
                </div>
                <div class="jss60">
                  <p class="MuiTypography-root jss62 MuiTypography-body1">{{artsit.category}}</p>
                  <div class="jss63">
                    <p class="MuiTypography-root MuiTypography-body1 black--text">{{artsit.author}}</p>
                  </div>
                  <div class="jss101">
                    <p class="MuiTypography-root MuiTypography-body2 black--text">
                      {{artsit.pieces}}
                    </p>
                  </div>
                  <!--  <div class="jss102">
                    <p class="MuiTypography-root MuiTypography-body2 black--text">
                      {{artsit.chart}}
                    </p>
                  </div> -->
                  <div class="jss65 mb-4">
                    <div class="MuiTypography-root MuiTypography-body2">{{ artsit.sales ? 'Sales' : 'Floor' }}</div>
                    <div class="MuiTypography-root MuiTypography-body2">
                      <span v-if="sumValueByArtsitId(artsit.id) > 0">
                      {{ '$' + $tools.formatNumber((sumValueByArtsitId(artsit.id) * solPrice).toFixed(2)) }}
                      </span>
                      <span v-else>
                        {{ '$' + $tools.formatNumber((artsit.solValue * solPrice).toFixed(2)) }}
                      </span>
                    </div>
                  </div>
                </div>
              </router-link>
              <a class="MuiButtonBase-root MuiButton-root MuiButton-contained jss66 MuiButton-containedSizeLarge MuiButton-sizeLarge Mui-disabled Mui-disabled"
                tabindex="-1" role="button" aria-disabled="true" data-testid="purchase-link" href="#"><span
                  class="MuiButton-label">View</span></a>
            </div>
          </div>
        </div>
      </div>
      <div class="jss54"></div>
    </div>
  </div>
</template>
<script>
  import HomeLogo from '@/components/HomeLogo';
  import MenuBar from '@/components/MenuBar';
  import {
    mapGetters
  } from "vuex";
  export default {
    data() {
      return {
        artsitList: [{
          id: 1,
          category: 'Artsit',
          author: 'Yin Kun',
          avator: 'https://imagedelivery.net/P4z5C24T1A4q673nx_eYTw/e4d04882-1b02-4f9d-7b5e-b385e1c40400/public',
          pieces: 'NFT Pieces: 5',
          floor: 'Floor',
          price: {
            data: [80,100,133,740,133,133,80]
          },
          solValue: '80.00',
          sales: true
        }, {
          id: 2,
          category: 'Artsit',
          author: 'Yin Jun',
          avator: 'https://imagedelivery.net/P4z5C24T1A4q673nx_eYTw/f11b8324-c16d-47a4-3f28-f2c9fadc8e00/public',
          pieces: 'NFT Pieces: 5',
          floor: 'Floor',
          price: '$6,000.00',
          solValue: '64.00',
          price:{
            data:[85,85,64,74,64]
          },
          sales: true
        }, {
          id: 3,
          category: 'Artsit',
          author: 'Huang Xi',
          avator: 'https://imagedelivery.net/P4z5C24T1A4q673nx_eYTw/6b7632ac-493c-4dc7-5e5a-53a6a9327800/public',
          pieces: 'NFT Pieces: 5',
          floor: 'Floor',
          price: '$8,000.00',
          solValue: '98.00',
          price: {
            data: [85,617,617,191,98,617,168,250]
          },
          sales: true
        }, {
          id: 4,
          category: 'Artsit',
          author: 'Liu Yujun',
          avator: 'https://imagedelivery.net/P4z5C24T1A4q673nx_eYTw/772955db-ee39-43bc-edee-089560265500/public',
          pieces: 'NFT Pieces: 5',
          floor: 'Floor',
          price: '$6,000.00',
          solValue: '64.00',
          price: {
            data: [64,106,64,138,85,85,85,128]
          },
          sales: true
        }, {
          id: 5,
          category: 'Artsit',
          author: 'Yang Peng',
          avator: 'https://imagedelivery.net/P4z5C24T1A4q673nx_eYTw/08a09528-0845-4cf0-bdf0-f4f35e374700/public',
          pieces: 'NFT Pieces: 4',
          floor: 'Floor',
          solValue: '85.00',
          price: {
            data: [128,106,138,128,85]
          },
          sales: true
        }, {
          id: 6,
          category: 'Artsit',
          author: 'Liu Fei',
          avator: 'https://imagedelivery.net/P4z5C24T1A4q673nx_eYTw/3f07cace-0045-40cd-e6d1-131db1114500/public',
          pieces: 'NFT Pieces: 5',
          floor: 'Floor',
          price: {
            data: [32,64,80,80,80,126]
          },
          solValue: '32.00',
          sales: true
        }, {
          id: 7,
          category: 'Artsit',
          author: 'Ma Yongqiang',
          avator: 'https://imagedelivery.net/P4z5C24T1A4q673nx_eYTw/edb3a471-eaf1-411a-e059-6090c463e900/public',
          pieces: 'NFT Pieces: 5',
          floor: 'Floor',
          price: '$5,000.00',
          solValue: '50.00',
          price: {
            data: [50,50,100,50,75,75]
          },
          sales: true
        }],
      }
    },
    components: {
      HomeLogo,
      MenuBar
    },
    created() {

    },
    mounted() {

    },
    computed: {
      ...mapGetters(["solPrice"]),
    },
    watch: {

    },
    methods: {
      sumValueByArtsitId(artsitId) {
        let artsit = this.artsitList.filter(artsit => artsit.id == artsitId)[0];
        let sum = 0;
        if(artsit && artsit.price && artsit.price.data) {
          artsit.price.data.forEach(solValue => sum += solValue);
        }
        return sum;
      }
    },
  }
</script>
<style lang="scss" scoped>
  .img_gray {
    /*grayscale(val):val值越大灰度就越深*/
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: gray;
  }

  .placeHolder {
    position: absolute;
    display: block;
    width: 100px;
    height: 50px;
    top: 600px;
  }
</style>



// WEBPACK FOOTER //
// src/views/home/Home.vue